import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import router from '@/router'
import {API_URL} from "@/common/config";
import store from '@/store/index'

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
        Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        Vue.axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';
        Vue.axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
        
        let isRefreshing = false;
        let subscribers = [];

        Vue.axios.interceptors.request.use(function(config) {
            config.headers.Authorization = `Bearer ${JwtService.getToken()}`;
            return config;
        }, function(err) {
            return Promise.reject(err);
        });

        Vue.axios.interceptors.response.use(
            response => {
                return response;
            },
            err => {
                const {
                    config,
                    response: { status, data }
                } = err;
            
                const originalRequest = config;
            
                if (originalRequest.url.includes("login")) {
                    return Promise.reject(err);
                }
            
                if (status === 401 && data.message === "Token has expired") {
                    if (!isRefreshing) {
                        isRefreshing = true;
                        return store.dispatch("refreshToken")
                            .then(({ status }) => {
                                if (status === 200 || status == 204) {
                                    isRefreshing = false;
                                    this.setHeader();
                                    onRefreshed();
                                    subscribers = [];
                                    return new Promise(resolve => {
                                        resolve(Vue.axios(originalRequest))
                                    })
                                }
                            })
                            .catch(error => {
                                console.error(error);
                                store.dispatch("logout")
                                    .then(() => router.push({name: "login"}));
                            });
                    }
                    else {
                        const requestSubscribers = new Promise(resolve => {
                            subscribeTokenRefresh(() => {
                                resolve(Vue.axios(originalRequest));
                            });
                        });
                        return requestSubscribers;
                    }
                } else {
                    return Promise.reject(err);
                }
            }
        );

        function subscribeTokenRefresh(cb) {
            subscribers.push(cb);
        }
          
        function onRefreshed() {
            subscribers.map(cb => cb());
        }
          
        subscribers = [];
    },

    setHeader(token) {
        if(!token) {
            Vue.axios.defaults.headers.common[
                "Authorization"
                ] = `Bearer ${JwtService.getToken()}`;
        } else {
            Vue.axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${token}`;
        }
    },

    setOrganizationHeader() {
        Vue.axios.defaults.headers.common[
            "Authorization"
            ] = `Bearer ${JwtService.getOrganizationToken()}`;
    },

    query(resource, params) {
        return Vue.axios.get(resource, params).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },

    get(resource, slug = "") {
        if (JwtService.getToken() !== null) {
            this.setHeader();
        } else if (JwtService.getOrganizationToken() !== null) {
            this.setOrganizationHeader();
        } else {
        }
        let params = '';
        if (!_.isNaN(slug)) {
            params = '?' + slug;
        }
        if (_.isObject(slug)) {
            params = '?' + _.keys(slug).filter(key => (slug[key] != null && slug[key] !== 'null'))
                .map(key => key + '=' + slug[key]).join('&');
        }
        return Vue.axios.get(`${resource}${params}`)
        .catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    },

    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    },

    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    put(resource, params, options) {
        if(options) {
            return Vue.axios.put(`${resource}`, params, options);
        } else {
            return Vue.axios.put(`${resource}`, params);
        }
    },

    delete(resource) {
        return Vue.axios.delete(resource).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    }
};

export default ApiService;
